import { HttpMethodEnum } from "../../data/models/HttpMethodEnum";
import { BaseApi } from "../../utils/BaseApi";
import {
  ApplicationRequest,
  CreditApplication,
  InstallmentRequest,
  UpdateInstallmentRequest,
} from "../models/applications/CreditApplication";
import { SoulAuthSession } from "../models/Soul/SoulAuthSession";
import {
  SoulDataModel,
  UpdateSoulInfoPayload,
} from "../models/Soul/SoulDataModel";
import { SoulLoginParams } from "../models/Soul/SoulLoginParams";
import { SoulSessionModel } from "../models/Soul/SoulSessionModel";

export class SoulApi extends BaseApi {
  private static instance: SoulApi;

  public static get(): SoulApi {
    if (!this.instance) {
      this.instance = new SoulApi();
    }
    return this.instance;
  }

  public soulLogin = BaseApi.createEndpoint<null, SoulLoginParams>(
    HttpMethodEnum.POST,
    "/soul/login"
  );

  public soulInfo = BaseApi.createEndpoint<SoulDataModel, null>(
    HttpMethodEnum.GET,
    "/soul"
  );

  public soulsInfo = BaseApi.createEndpoint<SoulDataModel[], null>(
    HttpMethodEnum.GET,
    "/soul/all"
  );

  public soulsGuarantors = BaseApi.createEndpoint<SoulDataModel[], null>(
    HttpMethodEnum.GET,
    "/soul/all/guarantors"
  );

  public updateSoulInfo = BaseApi.createEndpoint<
    SoulDataModel,
    UpdateSoulInfoPayload
  >(HttpMethodEnum.PUT, "/soul");

  public updateSoulInfoByAdmin = BaseApi.createEndpoint<
    null,
    UpdateSoulInfoPayload
  >(HttpMethodEnum.PUT, "/soul/update/admin");

  public soulAuth = BaseApi.createEndpoint<null, SoulSessionModel>(
    HttpMethodEnum.POST,
    "/soul/auth"
  );

  public soulCheckAuth = BaseApi.createEndpoint<
    SoulAuthSession,
    SoulSessionModel
  >(HttpMethodEnum.POST, "/soul/check-auth");

  public getCustomTokenAsAdmin = BaseApi.createEndpoint<
    SoulAuthSession,
    SoulSessionModel
  >(HttpMethodEnum.POST, "/soul/auth-user/admin");

  public createUserAsAdmin = BaseApi.createEndpoint<
    SoulAuthSession,
    SoulSessionModel
  >(HttpMethodEnum.POST, "/soul/create-user/admin");

  public soulApplications = BaseApi.createEndpoint<CreditApplication[], null>(
    HttpMethodEnum.GET,
    "/soul/applications"
  );


  public createSoulApplicationByAdmin = BaseApi.createEndpoint<null, any>(HttpMethodEnum.POST, '/soul/applications/admin');
  public createPersonalLoan = BaseApi.createEndpoint<null, any>(HttpMethodEnum.POST, '/soul/personal-loans');
  public getPersonalLoans = BaseApi.createEndpoint<any, null>(HttpMethodEnum.GET, '/soul/personal-loans');
  public updatePersonalLoan = BaseApi.createEndpoint<null, any>(HttpMethodEnum.PUT, '/soul/personal-loans');
  public createSoulApplication = BaseApi.createEndpoint<
    null,
    ApplicationRequest
  >(HttpMethodEnum.POST, "/soul/applications");

  public updateSoulApplication = BaseApi.createEndpoint<
    null,
    ApplicationRequest
  >(HttpMethodEnum.PUT, "/soul/applications");

  public updateSoulApplicationByAdmin = BaseApi.createEndpoint<
    null,
    ApplicationRequest
  >(HttpMethodEnum.PUT, "/soul/applications/admin");

  public createInstallmentApplication = BaseApi.createEndpoint<
    null,
    InstallmentRequest
  >(HttpMethodEnum.POST, "/soul/applications/installment");

  public updateInstallmentApplication = BaseApi.createEndpoint<
    null,
    UpdateInstallmentRequest
  >(HttpMethodEnum.PUT, "/soul/applications/installment");

  public soulAllApplications = BaseApi.createEndpoint<
    CreditApplication[],
    null
  >(HttpMethodEnum.GET, "/soul/all/applications");
  public createLeverage = BaseApi.createEndpoint<null, any>(HttpMethodEnum.POST, "/soul/leverages");
  public getLeverages = BaseApi.createEndpoint<any, null>(HttpMethodEnum.GET, "/soul/leverages");
  public updateLeverage = BaseApi.createEndpoint<null, any>(HttpMethodEnum.PUT, "/soul/leverages");
  public updatePaymentDate = BaseApi.createEndpoint<null, any>(HttpMethodEnum.PUT, "/soul/applications/payment-date");
  public anularMora = BaseApi.createEndpoint<null, any>(HttpMethodEnum.PUT, "/soul/applications/anular-mora");
}

export const soulApi = SoulApi.get();

